import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { IDataCaptureSegment } from '../../models/data-capture.models';
import { WINDOW } from '../../services/token';

@Component({
  selector: 'app-skeleton-data-capture',
  templateUrl: './skeleton-data-capture.component.html',
  styleUrls: ['./skeleton-data-capture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SkeletonDataCaptureComponent implements OnInit {
  @Input() sheetName: string;
  @Input() segments: IDataCaptureSegment[] = [];

  rows = Array(3).fill(null);

  constructor(@Inject(WINDOW) private window: Window) {}

  ngOnInit() {
    this.updateRowCount();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateRowCount();
  }

  private updateRowCount() {
    const width = this.window.innerWidth;

    if (width <= 576) {
      this.rows = [null];
    } else if (width <= 768) {
      this.rows = [null];
    } else if (width <= 992) {
      this.rows = [null];
    } else if (width <= 1024) {
      this.rows = [null, null];
    } else {
      this.rows = [null, null, null];
    }
  }
}
